
export const SECOND_ROUND_DROPDOWN_ACTIVE=false
export const DEFAULT_TAB="assessment" // or "setup"
export const ASSESSMENT_PERIOD="2025-2026"
//export const ASSESSMENT_PERIOD="2024-2025"
export const REVIEW_YEAR_1="2022-2023"
export const REVIEW_YEAR_2="2023-2024"
export const REVIEW_YEAR_3="2024-2025"
export const SETUP_MAPPING_VALIDATION_ERROR_1="Learning outcomes must be mapped to one or more Universal Themes"
export const SETUP_MAPPING_VALIDATION_ERROR_2="Each Universal Theme should be mapped to at least one learning outcome"
